import StepOptional from './stepOptional/StepOptional.jsx'
import StepObservations from './stepObservations/StepObservations.jsx'
import StepAdditional from './stepAdditional/StepAdditional.jsx'

import './variations.scss'

const Variations = ({variations, onClick: handleClick, onNext}) => {
    return <div className={'variations'}>
        {variations.map((variation, i) => {
            if (variation.minSelection === 1 && variation.maxSelection === 1) {
                return <StepOptional
                    key={i}
                    title={variation.variation}
                    options={variation.options}
                    step={variation.step}
                    stepIndex={variation.stepIndex}
                    priceStep={variation.price || 0}
                    onClick={handleClick}/>
            } else if (variation.options[0].sku.includes('O')) {
                return <StepObservations
                    key={i}
                    title={variation.variation}
                    options={variation.options}
                    step={variation.step}
                    stepIndex={variation.stepIndex}/>
            } else {
                return <StepAdditional
                    key={i}
                    title={variation.variation}
                    options={variation.options}
                    filterFlavor={variation.filterFlavor}
                    mandatory={(variation.minSelection >= 1)}
                    minSelection={variation.minSelection}
                    maxSelection={variation.maxSelection}
                    step={variation.step}
                    stepIndex={variation.stepIndex}
                    priceStep={variation.price || 0}
                    amountType={variation.amountType}
                    onNext={onNext}/>
            }
        })}
    </div>
}

export default Variations
